import type { Coupon } from '../api/coupons.service';

export function formatCentsToBrl(cents: number): string {
  return (cents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function parseBrlInputToCents(input: string): number {
  const cleaned = input.replace(/\./g, '').replace(',', '.').replace(/[^\d.]/g, '');
  return Math.round(parseFloat(cleaned || '0') * 100);
}

export function strategyLabel(c: Coupon): string {
  const s = c.discountStrategy;
  if (s === 'TRIAL_DAYS') return 'Dias grátis';
  if (s === 'PERCENTAGE') return 'Desconto %';
  if (s === 'FIXED_AMOUNT') return 'Desconto R$';
  return s || '—';
}

export function valueLabel(c: Coupon): string {
  const s = c.discountStrategy;
  if (s === 'TRIAL_DAYS') return `${c.value} dias`;
  if (s === 'PERCENTAGE') return `${c.value}%`;
  if (s === 'FIXED_AMOUNT') return `R$ ${(c.value / 100).toFixed(2).replace('.', ',')}`;
  return String(c.value);
}
